module.exports = __webpack_public_path__ + "img/xiaolu-logo.38d0c27e.png";